import { connect } from 'react-redux';
import { getListProducts, updateLoadingFlag } from 'Favourites/store/actions';
import { LIST_TYPE } from 'Favourites/store/constants';
import { selectNotifications } from 'Favourites/store/reducers';

import {
    selectProducts,
    selectIsLoading,
} from 'Favourites/store/reducers/data/products';

import {
    selectSelectedListId,
} from 'store/reducers/data/shoppingList';

const mapStateToProps = (state) => {
    const products = selectProducts(state);
    const selectedList = selectSelectedListId(state);
    const isLoading = selectIsLoading(state);
    const toastr = selectNotifications(state);

    return { products, selectedList, isLoading, toastr };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListProducts: (list) => {
            dispatch(getListProducts(list, LIST_TYPE));
        },
        updateLoadingFlag: (isLoading) => {
            dispatch(updateLoadingFlag(isLoading));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
